// extracted by mini-css-extract-plugin
export var aggregationCell = "_2k-k";
export var aggregationRow = "_2k-j";
export var borderlessSpinnerContainer = "_2k-3";
export var closeIcon = "_2k-c";
export var columnHeaderSurface = "_2k-8";
export var columnHeaderSurfaceDragOverlay = "_2k-s";
export var columnHeaderSurfaceResizing = "_2k-p";
export var contextMenuAnchor = "_2k-1";
export var draggableColumnHeader = "_2k-q";
export var draggableColumnHeaderOverlay = "_2k-r";
export var expandIcon = "_2k-d";
export var expanded = "_2k-e";
export var filterDropdown = "_2k-f";
export var filterDropdownDivider = "_2k-a";
export var filterDropdownHeader = "_2k-i";
export var filterDropdownItem = "_2k-h";
export var filterDropdownModal = "_2k-g _2k-f";
export var filterItem = "_2k-9";
export var normalCellWithAdjustableBorder = "_2k-b";
export var pinButtonContainer = "_2k-l";
export var pinIcon = "_2k-m";
export var pinIconActive = "_2k-n";
export var spinner = "_2k-0";
export var spinnerContainer = "_2k-2";
export var tableContainer = "_2k-4";
export var tableContentDraggingColumns = "_2k-7";
export var tableContentInner = "_2k-6";
export var tableContentWrapper = "_2k-5";
export var viewButtonContainer = "_2k-o";